export const OneTrustGroup = {
    StrictlyNecessary: "C0001",
    Performance: "C0002",
    Functional: "C0003",
    Marketing: "C0004",
} as const;

export const SHOULD_TRACK_BY_DEFAULT = false; // TODO: Depending on tracking in customer platform - TBD

export const CONFIGURATOR_CONSENT_MODE = OneTrustGroup.Performance;
